// The web-app also applies this when it shows a hand change before the server answers.
export const canCardBeInQueue = (card: {visibility: string; status: string}): boolean => {
  if (card.visibility === "deleted") return false;
  if (card.visibility === "archived" && card.status !== "done") return false;
  return true;
};
